
<template>
  <v-flex class="pl-2 mb-4 pr-2">
    <v-layout align-start justify-start row class="mb-4">
      <v-icon color="primary" style="font-size: 50px;">message</v-icon>
      <h2 :style="`color: ${$vuetify.theme.primary}`" class="mt-2">{{$translate('MESSAGES')}}</h2>
      <v-spacer></v-spacer>

      <v-btn fab :disabled="disableAdd" right color="secondary" @click="addMessage">
        <v-icon>add</v-icon>
      </v-btn>
    </v-layout>

    <v-spacer></v-spacer>
    <v-data-table
      :headers="headers"
      :items="filteredMessages"
      class="elevation-1 mb-2"
      :rows-per-page-items="[10]"
    >
      <template v-slot:items="props">
        <td>{{ props.item.Title }}</td>
        <td>{{ props.item.Text }}</td>
        <td>{{ props.item.DateTime }}</td>
        <td class="justify-center">
          <v-btn small class="v-btn-tiny mr-2" color="primary">
            <v-icon small>edit</v-icon>
          </v-btn>
          <v-btn small class="v-btn-tiny mr-2" color="primary">
            <v-icon small>delete</v-icon>
          </v-btn>
        </td>
      </template>
    </v-data-table>
    <SingleMessageDialog
      :eventData="eventData"
      :messageData="messageData"
      :showDialog="showMessageDialog"
      :isCampaign="isCampaign"
      v-on:closeDialog="closeDialog"
    />

    <v-dialog v-model="deleteDialog" persistent max-width="290">
      <v-card class="generic_dialog_class">
        <v-progress-linear v-if="showProgress" :indeterminate="true" color="blue"></v-progress-linear>
        <v-card-title class="headline" :style="`color: ${$vuetify.theme.primary}`">{{$translate('MESSAGE_DELETION')}}</v-card-title>
        <v-card-text>{{deleteText}}</v-card-text>
        <v-card-text>{{this.itemToBeDeleted.Title}}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="secondary"
            class="v-btn-2 text-capitalize"
            round
            @click.native="deleteDialog = false"
          >{{$translate('CANCEL')}}</v-btn>
          <v-btn
            color="primary"
            class="v-btn-2 text-capitalize"
            :loading="disableUpdate"
            :disabled="disableUpdate"
            round
            @click.native="deleteMessageConfirmation"
          >{{$translate('DELETE')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-flex>
</template>


<script>
import * as dssRequest from "@/api/dssRequest";
import appConfig from "../../../config/app_config";
import BaseObject from "@/objects/BaseObject";
import EventObject2 from "@/objects/EventObject2.js";
import CreateEventObject2 from "@/objects/CreateEventObject2";
import _ from "lodash";
import { weekdays } from "@/shared/utility";
import { mapGetters } from "vuex";
import { objectToArray } from "@/shared/utility.js";
import BaseComponent from "@/components/base/BaseComponent.vue";
import CommunicationCenterObject from "@/objects/CommunicationCenterObject";
import SingleMessageDialog from "@/components/SingleMessageDialog";

export default {
  extends: BaseComponent,
  name: "Events_Messages",
  components: {
    SingleMessageDialog
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Batchgroup" : "Edit Batchgroup";
    }
  },
  data() {
    return {
      eventData: {},
      messageData: {},
      deleteDialog: false,
      showProgress: false,
      itemToBeDeleted: {},
      disableUpdate: false,
      deleteText: "Are you sure to delete the Message?",
      isCampaign: false,
      disableAdd: true,
      eventForm: {},
      textRule: [
        v => !!v || "Field is required"
        // v => v != 0 || "Field must at least be 1 char long!"
      ],
      comboRule: [v => !!v || "Date(s) are required"],
      filteredMessages: [],
      defaultItem: {
        description: ""
      },
      showMessageDialog: false,
      headers: [
        {
          text: this.$translate('TITLE'),
          align: "center",
          sortable: true,
          value: "Title"
        },
        {
          text: this.$translate('TEXT'),
          align: "center",
          sortable: true,
          value: "Text"
        },
        {
          text: this.$translate('DATE'),
          align: "center",
          sortable: true,
          value: "DateTime"
        },
        {
          text: this.$translate('EVENT_ACTIONS'),
          align: "center",
          value: "Actions"
        }
      ]
    };
  },
  created() {
    if (this.$store.getters["auth/partnerId"] !== -1) this.isCampaign = true;
    window.EventBus.listen("dataForComponent", this.manageDataForComponent);
    window.EventBus.listen("getEventMessages", this.getEventMessages);
  },
  beforeDestroy() {
    window.EventBus.removeListener(
      "dataForComponent",
      this.manageDataForComponent
    );
    window.EventBus.removeListener("getEventMessages", this.getEventMessages);
  },
  methods: {
    closeDialog(reload = false) {
      this.showMessageDialog = false;
      if (reload == true) this.getEventMessages();
    },
    addMessage() {
      this.messageData = {};
      this.showMessageDialog = true;
    },
    deleteMessage(item) {
      this.itemToBeDeleted = item;
      this.deleteDialog = true;
    },
    deleteMessageConfirmation() {
      this.showProgress = true;
      this.disableUpdate = true;
      let payload = CommunicationCenterObject._deleteRequestObject(
        this.itemToBeDeleted.UnitId
      );
      payload.FunctionId = "MessageFunctionLibrary::deleteMessage";

      dssRequest.doRequest(
        response => {
          console.log("The generic call deleteMessage was successful", response);
          this.getEventMessages();
          setTimeout(() => {
            this.disableUpdate = false;
            this.deleteDialog = false;
            this.showProgress = false;
          }, 500);
        },
        error => {
          console.log("The generic call deleteMessage was not successful", error);
          setTimeout(() => {
            this.disableUpdate = false;
            this.deleteDialog = false;
            this.showProgress = false;
          }, 500);
        },
        "communicateWithDBLibrary",
        this.currentAccountId + "_CMR",
        payload
      );
    },
    showMessage(item) {
      const payload = {
        RelationType: "Message",
        Id: item.UnitId,
        Types: {
          "User":"User"
        },
        FunctionId: "TagsFunctionLibrary::getTagRelations",
        PartnerId: this.$store.getters['auth/partnerId']
      };
      dssRequest.doRequest(
        response => {
          console.log("The generic call getTagRelations(getTags) was successful", response);
          this.messageData = item;
          let tags = BaseObject._createArrayWithObjects(response.data.Tags);
          tags = tags.filter(e => e.Description !== "Temporary Administrator");
          this.$set(
            this.messageData,
            "tags",
            tags
          );
          this.showMessageDialog = true;
        },
        error => {
          console.log("The generic call getTagRelations(getTags) was not successful", error);
        },
        "communicateWithDBLibrary",
        this.currentAccountId + "_CMR",
        payload
      );
    },
    manageDataForComponent(data) {

      this.eventData = data;
      if (!_.isEmpty(data)) {
        this.disableFields(true);
        if (this.eventData.memberOf !== undefined) {
          this.eventData.memberOf.forEach(e => {
            if (
              e.grantType === "OWNER" &&
              e.accountId == this.currentAccountId
            ) {
              this.disableFields(false);
            }
          });
        }
      } else {
        this.disableFields(true);
      }
      this.tagData = data.tags;
      this.enableButton = true;
      this.eventMessages = [];
      if (!_.isEmpty(data)) {
        this.enableButton = false;
        this.getEventMessages();
      }
    },
    disableFields(status) {
      this.disableAdd = status;
    },
    getEventMessages() {
      let payload = CommunicationCenterObject._eventSavedMessagesRequestObject(
        this.eventData.eventId
      );
      if (Number(this.$store.getters["auth/partnerId"]) <= 0) {
        payload.PartnerId = -1;
      } else {
        payload.PartnerId = Number(this.$store.getters["auth/partnerId"]);
      }
      payload.FunctionId = "MessageFunctionLibrary::getSavedMessages";
      this.eventMessages = [];
      dssRequest.doRequest(
        response => {
          console.log("The generic call getSavedMessaged was successful", response);
          let messages = CommunicationCenterObject._parseEventSavedMessagesData(
            response.data
          );

          for (let [key, value] of Object.entries(messages)) {
            value.DateTime = value.DateTime.split(" ")
              .reverse()
              .join(" - ");
            this.eventMessages.push(value);
          }
          this.filteredMessages = this.eventMessages;
          this.enableCommunicationDetail = true;
        },
        error => {
          console.log("The generic call getSavedMessaged was successful", error);
        },
        "communicateWithDBLibrary",
        this.currentAccountId + "_CMR",
        payload
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.scrollableBatchgroupList {
  height: 30em;
  margin-bottom: 2em;
  overflow-x: hidden;
  overflow-y: auto;
}
</style>
